import { GetPodcastMetricsByDayArgs } from 'api';

export const metricsQueries = {
  all: [{ scope: 'podcastMetrics' }] as const,
  general: (podcastId: string) => [{ ...metricsQueries.all[0], podcastId }],
  aggregated: (podcastId: string, groupBy: string) => [
    { ...metricsQueries.general(podcastId)[0], groupBy },
  ],

  byEpisode: (podcastId: string) => [
    {
      ...metricsQueries.aggregated(podcastId, 'episode')[0],
    },
  ],
  byDay: ({ podcastId, ...rest }: GetPodcastMetricsByDayArgs) =>
    [
      {
        ...metricsQueries.aggregated(podcastId, 'day')[0],
        ...rest,
      },
    ] as const,
};

export const ownedPodcastQueries = {
  all: [{ scope: 'ownPodcasts' }] as const,
  podcast: (podcastId: string) => [
    { ...ownedPodcastQueries.all[0], podcastId },
  ],
  followers: (feedId: number) => [{ ...ownedPodcastQueries.all[0], feedId }],
};
